import { upper, type JanusCtx, type Row } from '../ability/context.js';
import type { ShapeshiftInventoryWrite } from './shapeshift-inventory.js';

/** Read the inventory after earlier form work in this use, without changing a borrowed row. */
export function formInventoryField(ctx: JanusCtx, row: Row, key: string): unknown {
  const read = ctx.read.inventoryField;
  const id = upper(read?.(row, 'inventory_id'));
  for (let i = (ctx.shapeshiftInventory?.length ?? 0) - 1; i >= 0; i--) {
    const write = ctx.shapeshiftInventory![i]!;
    if (upper(write.inventory_id) !== id) continue;
    if (key === 'inventory_private' && write.kind !== 'unequip_acquired') return write.kind === 'absorb' ? 2 : 0;
    if (key === 'equipped' && write.kind === 'unequip_acquired') return '';
  }
  return read?.(row, key);
}

/** A restore followed by absorption is a net zero privacy delta; equipment is an independent column. */
export function appendFormInventoryWrites(ctx: JanusCtx, writes: readonly ShapeshiftInventoryWrite[]): void {
  // Dry-run contexts share the initial empty list; each verdict owns its write list.
  const planned = [...ctx.shapeshiftInventory ?? []];
  for (const write of writes) {
    const prior = planned.findIndex(other => upper(other.inventory_id) === upper(write.inventory_id)
      && (other.kind === 'unequip_acquired') === (write.kind === 'unequip_acquired'));
    if (prior < 0) planned.push(write);
    else if (planned[prior]!.kind !== write.kind) planned.splice(prior, 1);
  }
  ctx.shapeshiftInventory = planned;
}
